import React from 'react'
import PlaceholderReviews from './PlaceholderReviews'

import { CallToActionBox } from 'components/supplier_show/hidden_reviews/CallToActionBox'
import { CtaHeading } from 'components/supplier_show/hidden_reviews/CtaHeading'

import WhereAreReviewsIcon from 'images/where-are-reviews-logo.png'

import { HiddenReviewsText, HiddenReviewsTextProps } from './HiddenReviewsText'
import { JoinButton } from './JoinButton'

export interface HiddenReviewsProps extends HiddenReviewsTextProps {}

export const HiddenReviews: React.FC<HiddenReviewsProps> = (props) => {
  const icon = <img src={WhereAreReviewsIcon} alt='Where are reviews icon' />
  const actions = <JoinButton>Join and Read Reviews</JoinButton>

  return (
    <PlaceholderReviews>
      <CallToActionBox icon={icon} actions={actions}>
        <CtaHeading>
          Where are the reviews?
        </CtaHeading>
        <HiddenReviewsText {...props} />
      </CallToActionBox>
    </PlaceholderReviews>
  )
}
